import { useEffect, useRef, useState } from 'react'
import Box from "@mui/material/Box"
import Input from "@mui/material/Input"
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from '@mui/material/IconButton';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { ReactComponent as DeleteIcon } from "../../../assets/images/delete1.svg";
import SettingTextField from "../../../components/SettingTextField";

export const MODES = {
    IMAGE: 'image',
    COLOR: 'color'
}

const ImageColorComponent = ({ value, onChange, uploadFile, label, required = true, imageFieldKey, colorFieldKey, placeholder = "", styles, error, sx = {}, isLoading }) => {
    const timerRef = useRef(null);
    const [mode, setMode] = useState(value.color ? MODES.COLOR : MODES.IMAGE);

    useEffect(() => {
        if (value.color && !value.image) setMode(MODES.COLOR);
        if (value.image && !value.color) setMode(MODES.IMAGE);
    }, [value]);

    const handleValueChange = (val) => {
        if (isLoading) return;
        onChange(mode === MODES.IMAGE ? imageFieldKey : colorFieldKey, val);
    }

    const handleDelete = () => {
        if (isLoading) return;
        handleValueChange(null);
    }

    const handleModeChange = (mode) => {
        if (isLoading) return;
        setMode(mode);
    }

    const handleInputDelay = (val) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => handleValueChange(val), 100);
    }

    const onFileUpload = (file) => {
        if (isLoading) return;
        uploadFile(imageFieldKey, file);
    }

    const inputValue = mode === MODES.IMAGE ? typeof value.image === 'string' ? value.image : value.image?.location ?? "" : value.color;

    return (
        <SettingTextField
            value={inputValue ?? ""}
            setValue={handleValueChange}
            placeholder={placeholder}
            required={required}
            editable={!isLoading}
            label={label}
            labelStyle={styles.labelStyle}
            variant={"filled"}
            error={error}
            textInputCss={{ textTransform: 'uppercase', '& input': { paddingLeft: mode === MODES.IMAGE ? '2.5rem !important' : 0 }, ...sx }}
            border="1px solid #AAA"
            leftView={mode === MODES.IMAGE ? <Box sx={{ position: 'relative' }}>
                <FileUploadOutlinedIcon sx={{ position: 'absolute', zIndex: 0, top: '-24px', width: '2rem', height: '2em', left: 0 }} />
                <Input
                    type="file"
                    sx={{ position: 'absolute', opacity: 0, zIndex: 1, top: '-24px', left: 0, width: '2rem', padding: 0, '& input': { height: '2em', borderRadius: '12px' } }}
                    inputProps={{ accept: "image/*", multiple: false }}
                    value={""}
                    onChange={(e) => onFileUpload(e.target.files[0])} />
            </Box> : <Input
                type="color"
                sx={{ width: '2rem', marginRight: '0.75rem', padding: 0, '& input': { height: '2em', borderRadius: '12px' } }}
                value={value.color ? value.color : "#000000"}
                onChange={(e) => handleInputDelay(e.target.value.toUpperCase())}
                onMouseUp={() => { if (isLoading) return; }}
            />
            }

            rightView={< InputAdornment position="end" >
                <IconButton onClick={handleDelete}>
                    <DeleteIcon width={22} height={22} viewBox="0 0 22 22" />
                </IconButton>
                <IconButton
                    sx={{
                        backgroundColor: mode === MODES.IMAGE && !isLoading ? "#ffffff" : "#transparent",
                        borderRadius: "12px",
                        padding: '4px',
                        marginLeft: '2px',
                        '&:hover': {
                            backgroundColor: "#ffffff"
                        }
                    }}
                    onClick={() => handleModeChange(MODES.IMAGE)}
                >
                    <ImageOutlinedIcon sx={{ fill: mode === MODES.IMAGE ? "#000000" : "#aaa", '&:hover': { fill: "#000000" } }} />
                </IconButton>
                <IconButton
                    sx={{
                        backgroundColor: mode === MODES.COLOR && !isLoading ? "#ffffff" : "transparent",
                        borderRadius: "12px",
                        padding: '4px',
                        marginLeft: '2px',
                        '&:hover': {
                            backgroundColor: "#ffffff"
                        }
                    }}
                    onClick={() => handleModeChange(MODES.COLOR)}
                >
                    <PaletteOutlinedIcon sx={{ fill: mode === MODES.COLOR ? "#000000" : "#aaa", '&:hover': { fill: "#000000" } }} />
                </IconButton>
            </InputAdornment >}
        />
    )
}

export default ImageColorComponent
